var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  fill: "none",
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B1C1C",
  fillRule: "evenodd",
  d: "M.667 1.2c0-.294.213-.533.476-.533h.952c.263 0 .477.239.477.533v9.6c0 .295-.214.534-.477.534h-.952a.45.45 0 0 1-.337-.157.57.57 0 0 1-.14-.377zm4.762 0c0-.294.213-.533.476-.533h.952c.127 0 .248.056.337.156s.14.236.14.377v9.6c0 .295-.214.534-.477.534h-.952c-.263 0-.476-.24-.476-.534z",
  clipRule: "evenodd"
})));
export { SvgPause as ReactComponent };
export default __webpack_public_path__ + "6adfde31bb5b2b4e3d5a40f1f1a5877d.svg";